<template>
  <div class="print-tag-batches">
    <transition
      name="fade"
      mode="out-in"
    >
      <div class="print-tag-batches__card-container">
        <div
          v-for="(batchUnprinted, index) in batchesUnprinted"
          :key="'batchesUnprinted' + index"
          :md-item="batchesUnprinted"
          class="card-box"
          :class="{ 'collapsed': batchUnprinted.expanded }"
        >
          <batch-card
            :index="index"
            :batch="batchUnprinted"
          />
        </div>

        <div
          v-if="batchesPrinted && batchesPrinted.length > 0"
          :class="{
            'subsection-container-alternative': hasBatchesPrinted && !hasBatchesUnprinted
          }"
          class="subsection-container"
        >
          <h2>Impressos</h2>
          <hr>
        </div>

        <div
          v-for="(batchPrinted, index) in batchesPrinted"
          :key="'batchesPrinted' + index"
          :md-item="batchesUnprinted"
          class="card-box-printed"
        >
          <batch-card
            :index="index"
            :batch="batchPrinted"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import mixin from './BatchesMixin'
import BatchCard from './Cards/BatchCard'
import { mapGetters } from 'vuex'

export default {
  name: 'BatchesGrid',
  components: {
    'batch-card': BatchCard
  },
  mixins: [mixin],
  computed: {
    ...mapGetters(['batchesUnprinted']),
    ...mapGetters(['batchesPrinted'])
  }
}
</script>

<style lang="scss" scoped>
.print-tag-batches {
    &__card-container {
      align-items: flex-start;
      display: flex;
      height: 100%;
      flex-grow: 1;
      flex-wrap: wrap;
      justify-content: flex-start;
      margin-left: 0;
      padding: 0;

      .card-box {
        margin: 15px 30px 30px 0px;

        &-printed {
          margin: 15px 30px 40px 0px;
        }
      }
      .collapsed {
        width: 100%;
        display: flex;
      }
    }

    .subsection-container {
      width: 100%;
      padding-top: 100px;

      &-alternative {
        padding-top: 30px !important;
      }

      h2 {
        font-size: 18px;
        font-weight: 400;
        letter-spacing: -0.3px;
        text-align: left;
        color: #7a7a7a;
        line-height: 1.09;
      }

      hr {
        margin-top: 15px;
        margin-bottom: 15px;
        background-color: #828282;
        height: 0.11em;
        border: 0;
        width: 95%;
        opacity: 0.9;
      }
    }
    &-empty-reload-snackbar.md-snackbar {
      bottom: -10px;

      .md-snackbar {
        &-container {
          min-width: 910px;
          padding: 13px 24px;
          background-color: #7c0a02;
        }

        &-content {
          display: flex;
          flex-direction: row;
          height: 12px;
          letter-spacing: -0.5px;
        }
      }

      .md-button {
        color: rgba(255, 255, 255, 0.5);
        padding: 0 10px;
        margin: -11px 0 0 25px;

        &:last-child {
          margin-left: 2px;
          color: #e1e1e1;
        }
      }
    }

    .md-list {
      width: 80%;
      padding-top: 0;
      margin-left: 21px;
    }
  }
</style>
